<script lang="ts">
import { defineComponent, ref, computed } from '@vue/composition-api';

import { useCsrfTokenDialogModule } from '@/store/global/appComponents/appCsrfToken';

export default defineComponent({
    name: 'AppCsrfTokenDialog',

    // eslint-disable-next-line
    setup(props, ctx) {
        const isFullScreen = ref(false);

        const store = useCsrfTokenDialogModule();
        const isOpen = computed({
            get: () => store.state.isOpen,
            set: (val) => {
                if (val === false) {
                    //store.dispatch(new CloseCsrfTokenDilaog());
                    store.state.isOpen = false;
                }
            },
        });

        const onReload = () => {
            location.reload();
        };
        return {
            isFullScreen,
            isOpen,
            onReload,
        };
    },
});
</script>

<template>
  <v-dialog
    v-model="isOpen"
    width="1084"
    :fullscreen="$vuetify.breakpoint.mdAndDown || isFullScreen"
    persistent
  >
    <v-card class="pb-2">
      <v-card-title class="headline">
        Session expired
      </v-card-title>
      <template v-if="isOpen">
        <v-card-text class="mb-0">
          <v-alert
            type="info"
            text
            prominent
            class="mb-0"
          >
            We're sorry, but <span class="font-weight-bold"> your session has expired.</span> 
            We kindly ask you  <span class="font-weight-bold">to reload the page </span> before continuing your work.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" depressed @click="onReload">
            Reload now
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>
